import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator,
} from "src/components/ui/breadcrumb";
import { isMatch, Link, useMatches } from "@tanstack/react-router";
import { Home } from "lucide-react";
import { Fragment } from "react";

export const BreadcrumbNav = () => {
  const matches = useMatches();
  const matchesWithCrumbs = matches.filter((match) =>
    isMatch(match, "loaderData.crumb"),
  );

  const items = matchesWithCrumbs.map(({ pathname, loaderData }) => {
    return {
      href:
        loaderData && "crumbPathname" in loaderData
          ? loaderData?.crumbPathname
          : pathname,
      label: loaderData?.crumb,
    };
  });

  return (
    <Breadcrumb className={"h-breadcrumb-height"}>
      <BreadcrumbList>
        <BreadcrumbItem>
          <BreadcrumbLink asChild>
            <Link to={"/"}>
              <Home size={12} />
            </Link>
          </BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbSeparator />
        {items.map((match, index) => (
          <Fragment key={match.href}>
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to={match.href}>{match.label}</Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            {index < items.length - 1 && <BreadcrumbSeparator />}
          </Fragment>
        ))}
      </BreadcrumbList>
    </Breadcrumb>
  );
};
